export { default as AppointmentDetails } from './AppointmentDetails';
